import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NbButtonModule, NbDialogModule, NbIconModule, NbListModule, NbSpinnerModule, NbTooltipModule } from '@nebular/theme';
import { LobbyPanelComponent } from './lobby-panel.component';

@NgModule({
  declarations: [
    LobbyPanelComponent
  ],
  imports: [
    CommonModule,
    Ng2SmartTableModule,
    NbListModule,
    NbSpinnerModule,
    NbDialogModule,
    NbButtonModule,
    NbIconModule,
    NbTooltipModule
  ]
})
export class LobbyPanelModule { }
